(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/assets/javascripts/router.js');
'use strict';

const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService;
const {
  useMediaQuery,
  breakpoints
} = svs.components.lbUtils.useMediaQuery;
const {
  ModalPortal,
  ModalHidden
} = svs.components.lbUi.modal;
const {
  NavContextProvider
} = svs.oddset_kambi.components.nav_context;
const {
  setHeaderImageAltText
} = svs.components.lbUtils.setMetaTags;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const oddsmindConfig = svs.oddset_kambi.data.oddsmindConfig;
const isOddsmindChatLoaded = svs.oddset_kambi.data.isOddsmindChatLoaded;
const {
  oddsmindNavigate
} = svs.oddset_kambi.components.oddsmind_chat;
const isInTarget = svs.components.targeting.isTargeted('oddset_oddsmind', 'B');
const {
  useEffect,
  useRef
} = React;
const displayOddsmindChat = svs.core.detect.feature('ft-oddsmind-chat') && isOddsmindChatLoaded;
const {
  BrowserRouter: Router,
  Route,
  Switch
} = ReactRouterDOM;
const {
  pages: {
    PlayPage,
    GameGuidePage,
    WidgetPage
  },
  components: {
    nav_menu: {
      OddsetNavMenu
    },
    seo_articles: {
      SeoArticles
    }
  }
} = svs.oddset_kambi;
const {
  MenuTabTypes
} = svs.oddset_kambi.components.common.constants;
const getPageComponent = tabType => {
  switch (tabType) {
    case MenuTabTypes.Play:
      return PlayPage;
    case MenuTabTypes.GameGuide:
      return GameGuidePage;
    case MenuTabTypes.Widget:
    default:
      return WidgetPage;
  }
};
const navmenuHeight = 66;
const OddsetRouter = () => {
  var _svs$oddset_kambi$dat, _svs, _svs$oddset_kambi$dat2, _svs2;
  const routes = (_svs$oddset_kambi$dat = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.oddset_kambi) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.tabsConfig) !== null && _svs$oddset_kambi$dat !== void 0 ? _svs$oddset_kambi$dat : [];
  const routePlay = (_svs$oddset_kambi$dat2 = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.oddset_kambi) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.tabsConfigPlay) !== null && _svs$oddset_kambi$dat2 !== void 0 ? _svs$oddset_kambi$dat2 : {};
  const oddsmindRef = useRef(null);
  const isSmallScreen = useMediaQuery(breakpoints.down(1080)); 
  const renderMobileMenu = !isSelfService && isSmallScreen;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const classNames = [renderMobileMenu ? 'oddset-bg-layer--mobile' : 'oddset-bg-layer--desktop', isSelfService ? 'oddset-bg-layer--selfservice' : '', isLoggedIn ? 'oddset-bg-layer--logged-in' : ''];
  useEffect(() => {
    if (oddsmindRef.current) {
      oddsmindRef.current.addEventListener('bet_intercept', e => {
        e.preventDefault();
        oddsmindNavigate(e.detail);
      });
    }
  }, []);
  return React.createElement(Router, {
    basename: svs.core.data.baseUrl
  }, displayOddsmindChat && isInTarget && React.createElement("oddsmind-chat", {
    "api-url": "https://chat.oddsmind.ai",
    backdrop: "none" 
    ,
    "bookmaker-id": "32",
    "bottom-offset": "".concat(isSmallScreen ? navmenuHeight : ''),
    "client-id": "svenskaspel",
    country: "SE",
    "footer-label": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.linkText) || 'OddsMind'),
    "footer-note": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.footerNote) || ''),
    "footer-prefix": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.footerPrefix) || ''),
    "footer-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.link) || 'https://oddsmind.ai') 
    ,
    "intercept-bets": "true",
    language: "sv",
    mode: "floating" 
    ,
    "parent-origin": "".concat(window.location.origin),
    position: "bottom-right",
    ref: oddsmindRef,
    subtitle: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.subheader) || 'AI Betting Assistant'),
    title: "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.header) || 'OddsMind')
    ,
    "widget-key": "widget_sOpEbLybS6h5QD201n6JpMZ12shh4_bvBGRfMO7e8E0" 
    ,
    "z-index": "301"
  }), React.createElement(NavContextProvider, null, React.createElement(ModalPortal, null, React.createElement(ModalHidden, null, React.createElement("div", {
    className: "oddset oddset-bg-layer ".concat(classNames.join(' '))
  }, React.createElement(CampaignFlerp, null), React.createElement(OddsetNavMenu, {
    activeRoutes: routes,
    playRoute: routePlay,
    renderMobileMenu: renderMobileMenu
  }), React.createElement("div", {
    className: "oddset-content".concat(renderMobileMenu ? ' oddset-content--mobile' : '')
  }, React.createElement(Switch, null, routes.filter(route => !route.isPlayRoute).map(route => React.createElement(Route, {
    key: route.path,
    path: "/".concat(route.path),
    render: () => {
      const Component = getPageComponent(route.tabType);
      setHeaderImageAltText((route === null || route === void 0 ? void 0 : route.logotypeAltText) || "Oddset - ".concat(route.label));
      return React.createElement(Component, {
        widgetAreaIndex: route.widgetArea
      });
    }
  })), React.createElement(Route, {
    key: "playpage",
    path: [routePlay.path, ...routes.filter(route => route.isPlayRoute).map(route => route.path)],
    render: () => React.createElement(PlayPage, null)
  }))), React.createElement("div", {
    id: "KambiBC"
  })), React.createElement(SeoArticles, null)))));
};
setGlobal('svs.oddset_kambi.OddsetRouter', OddsetRouter);

 })(window);